import { useBlogMyChannels, useBlogPostsSearch } from "@/queries/blog.query.ts";
import { CardMini, FontAwesomeIcon, Stack, Title, toColorName } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function HomeNews() {
  const { t } = useTranslation();
  const { data: channels } = useBlogMyChannels();
  const { data: postPages } = useBlogPostsSearch(
    {
      page_number: 1,
      channel_ids:
        channels?.reduce((acc: number[], channel) => {
          if (channel.is_subscribed) acc.push(channel.id);
          return acc;
        }, []) ?? [],
    },
    !!channels
  );
  const flatData = useMemo(() => {
    const posts = postPages?.pages?.flatMap((page) => page?.items ?? []) ?? [];

    return posts
      .filter((post) => {
        return (post.datetime_published_at?.getTime() ?? 0) - new Date().getTime() < 0;
      })
      .slice(0, 4);
  }, [postPages]);

  if (flatData.length < 1) return null;

  return (
    <>
      <Title
        header={t("core:news")}
        size={"lg"}
        paddingBottom
        paddingTop
        actionIcon={<FontAwesomeIcon icon={"fa-solid fa-chevron-right"} />}
        to={"/news"}
      />
      <Stack gap={"md"} direction={"horizontal"} className={"w-full"}>
        {flatData.map((post, index) => {
          const channelTitle =
            post.channels && post.channels.length > 0 ? post.channels[0].title : "";

          return (
            <CardMini
              key={`post-cover-${post.id}`}
              title={channelTitle}
              caption={post.title}
              backgroundUrl={post.hero_image_file?.url}
              accentColor={toColorName(post.color)}
              to={`/news/posts/${post.id}`}
              size={index == 0 ? "flex" : "fix"}
            />
          );
        })}
      </Stack>
    </>
  );
}
